import React from 'react';

const JsonLd = () => {
  const siteUrl = 'https://nextcore-ict.com';
  
  // Organization Schema
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Next Core ICT Solutions",
    "url": siteUrl,
    "logo": `${siteUrl}/new_logo/logo.png`,
    "description": "Custom web applications, POS systems, and professional website development for businesses, schools, and SMEs in the Philippines",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "PH",
      "addressRegion": "Philippines"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "email": "info@nextcore-ict.com"
    },
    "sameAs": [
      "https://facebook.com/nextcore-ict",
      "https://linkedin.com/company/nextcore-ict",
      "https://twitter.com/nextcore-ict"
    ]
  };

  // Service Schema
  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Custom Web Development",
    "description": "Custom web applications, POS systems, inventory management, and professional website development",
    "provider": {
      "@type": "Organization",
      "name": "Next Core ICT Solutions"
    },
    "areaServed": [
      {
        "@type": "Country",
        "name": "Philippines"
      },
      {
        "@type": "Place",
        "name": "Remote"
      }
    ],
    "serviceType": "Web Development",
    "offers": {
      "@type": "Offer",
      "priceRange": "₱25,000 - Custom",
      "priceCurrency": "PHP"
    }
  };

  // FAQ Schema
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How fast can we start?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Discovery can begin within 3–5 business days. We prioritize quick turnaround while ensuring thorough planning."
        }
      },
      {
        "@type": "Question",
        "name": "Do you handle hosting and SSL?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes—setup, SSL, backups, and monitoring are available. We provide complete infrastructure management."
        }
      },
      {
        "@type": "Question",
        "name": "Do you build POS and inventory systems?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes—barcode-ready, multi-location, printable receipts. Our systems handle complex retail operations."
        }
      },
      {
        "@type": "Question",
        "name": "Can you integrate AI chatbots?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes—we add site chatbots for lead capture and support. Custom AI solutions for your specific needs."
        }
      }
    ]
  };

  // HowTo Schema
  const howToSchema = {
    "@context": "https://schema.org",
    "@type": "HowTo",
    "name": "How to start a project with Next Core",
    "description": "Step-by-step process to begin your custom web development project",
    "totalTime": "P1W",
    "supply": [
      {
        "@type": "HowToSupply",
        "name": "Project requirements"
      },
      {
        "@type": "HowToSupply",
        "name": "Business goals"
      }
    ],
    "step": [
      {
        "@type": "HowToStep",
        "name": "Discover",
        "text": "We analyze your goals, constraints, and risks to understand your needs",
        "position": 1
      },
      {
        "@type": "HowToStep",
        "name": "Design",
        "text": "We create wireframes, data flows, and security models for your solution",
        "position": 2
      },
      {
        "@type": "HowToStep",
        "name": "Build",
        "text": "We develop your solution using sprints with weekly demos and feedback loops",
        "position": 3
      },
      {
        "@type": "HowToStep",
        "name": "Launch & Support",
        "text": "We deploy your solution with monitoring, updates, and training",
        "position": 4
      }
    ]
  };

  // WebSite Schema with SearchAction
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Next Core ICT Solutions",
    "url": siteUrl,
    "description": "Custom web applications and ICT solutions for businesses",
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": `${siteUrl}/search?q={search_term_string}`
      },
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <>
      <script 
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script 
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(serviceSchema) }}
      />
      <script 
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <script 
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(howToSchema) }}
      />
      <script 
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
    </>
  );
};

export default JsonLd;
